import {useEffect, useState} from "react";
import {useVscServerClient} from "../kova/vscServerClient";
import {useVscContext} from "../components/content/VscReactContext";

const DefaultConfig = `
^([^!]*)!([^!]*)$ => $1:$2
^([^!]*)!([^!]*)!([^!]*)$ => $1:$2_$3
^([^!]*)!([^!]*)!([^!]*)!([^!]*)$ => $1:$2_$3_$4
`;

async function fetchConfig(url:string) {
    const jsonResponse = await fetch(url);
    const unrealConfig = await jsonResponse.text();
    return unrealConfig;
}
export function useUnrealConfig() {
    const vscContext = useVscContext();
    const uri = vscContext.getHtmlContentUri("_config/unreal_config.txt");
    const [config, setConfig] = useState<null|string>(null);
    useEffect(() => {
        fetchConfig(uri).then(c => {
            setConfig(c);
        }).catch(err => {
            console.error(err);
            setConfig(DefaultConfig);
        });
    }, []);
    return config;
}
